import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider, useRouteError } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store, persistor } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import Auth0Provider from './components/Auth0Provider';
import App from './App';
import '@blueprintnyc/bpnyc-common-admin/dist/main.css';

import 'antd/dist/antd.css';
import './index.scss';
import * as Sentry from '@sentry/react';
import config from './config';
import syncSentryUser from './syncSentryUser';
import PostHogContextProvider from './components/PostHog/PostHogProvider';

window.ac = { getState: store.getState };

const rootElement = document.getElementById('root');

if (config.SENTRY_CONFIG) {
	Sentry.init(config.SENTRY_CONFIG);
	syncSentryUser(store);
}

// Rethrown so render errors reach Sentry instead of stopping at the data router's error screen.
const RethrowRouteError = () => {
	throw useRouteError();
};

// A single splat route keeps App's <Routes> and makes data router hooks like useBlocker work.
const router = createBrowserRouter([
	{
		path: '*',
		element: (
			<PostHogContextProvider>
				<Auth0Provider>
					<App />
				</Auth0Provider>
			</PostHogContextProvider>
		),
		errorElement: <RethrowRouteError />,
	},
]);

const APPLICATION = (
	<Provider store={store}>
		<PersistGate loading={null} persistor={persistor}>
			<RouterProvider router={router} />
		</PersistGate>
	</Provider>
);

createRoot(rootElement).render(APPLICATION);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
